<template>
  <div>
    <NotificationsComponent context="BuyflowComponent" />
    <div class="content">
      <article class="main constrain-90 pa-desktop">
        <BuyProgressbar />
        <h1>{{ tn("h1OrderConfirmation") }}</h1>
        <h3 class="mb">{{ tn("congratulations") }}</h3>
        <p v-if="buyFlowStore.isRenewOrUpgrade">
          {{ tn("subscriptionRenewedOrUpgraded") }}
        </p>
        <p v-else>{{ tn("subscriptionIsActivated") }}</p>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="tn('nextWeRecommend')"></p>
        <ul class="disc mb">
          <li>{{ tn("bullet1") }}</li>
          <li>{{ tn("bullet2") }}</li>
        </ul>
        <div class="mb-double no-print">
          <button type="button" class="btn-primary" @click="continueToMyAccount()">
            {{ tn("btnContinue") }}
          </button>
        </div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="mb-space-and-a-half" v-html="tn('orderConfirmationConclusion')"></p>
        <Receipt class="mb" />
        <AccountCreditEarned :adjustments="buyFlowStore.cart?.adjustments || []" />
      </article>
      <LoadingBoxComponent
        :show-dialog="buyFlowStore.showProcessingOrderMessage || false"
        :message="t('Common.loading')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
//Components
import Receipt from "./Receipt.vue";
import BuyProgressbar from "../BuyProgressbar.vue";
//Others
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { useRouter } from "vue-router";
import { onBeforeMount } from "vue";
import { changePageState, continueToMyAccount } from "@/components/Buy/BuyHelper";
import { pageStates as buyFlowPageStates } from "@/components/Buy/BuyEnums";
import { useBuyFlowStore } from "@/stores/buyFlow";
import AccountCreditEarned from "@/components/Buy/AccountCreditEarned.vue";
import NotificationsComponent from "@/components/shared/Notifications.vue";
import LoadingBoxComponent from "@/components/shared/LoadingBox.vue";
import { useNotificationsStore } from "@/stores/notifications";

const componentName = "OrderConfirmation";
logEvent("created", componentName);
const router = useRouter();
const buyFlowStore = useBuyFlowStore();

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${componentName}.${v}`, params);
}

onBeforeMount(() => {
  /* setting pageState so progressbar updates correctly */
  changePageState(buyFlowPageStates.orderConfirmation);
  onBrowserBack();
});

function onBrowserBack() {
  window.history.pushState(null, "", window.location.href);
  window.onpopstate = () => {
    const notificationsStore = useNotificationsStore();
    notificationsStore.addNotification({ type: "PurchaseDoneContinueToMyAccountPage" });
    router.go(1);
  };
}
</script>
<style scoped lang="css">
@import "@/styles/variables.css";
</style>
